<template>
  <modal
    id="doi-modal"
    name="doi-modal"
    :draggable="isMobile() ? false : '.modal-header'"
    class="doi-modal"
    width="450"
    height="465"
    @before-open="beforeOpen"
  >
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">{{ $t("nav.doi") }}</h5>
        <button
          type="button"
          class="close"
          data-dismiss="modal"
          aria-label="Close"
          @click="$modal.hide('doi-modal');"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="doi-modal-contactus">
          <div>
            <a href="tel:+48746649154">tel.: +48 74 664 91 54</a>
          </div>
          <div>
            <a href="mailto:biznes@invest-park.com.pl">e-mail: biznes@invest-park.com.pl</a>
          </div>
        </div>
      </div>
    </div>
  </modal>
</template>

<script>
export default {
  props: {
    currlang: String
  },
  data() {
    return {
      items: []
    };
  },
  methods: {
    getDOI() {
      this.$http(`/users`, { params: { typ: "Pracownik" } }).then(r => {
        this.items = r.data.uzytkownicy;
      });
    },
    beforeOpen() {
      this.getDOI();
    }
  }
};
</script>

